<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Image -->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            src="/banner.jpeg"
            alt="Login"
          />
        </div>
      </b-col>

      <!-- Right Login Form -->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Login
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to open admin portal.
          </b-card-text>

          <!-- Form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- Email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                  <b-form-input
                    id="login-email"
                    v-model="ulogin.email"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="hammad@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                </div>
                <validation-provider #default="{ errors }" name="Password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input
                      id="login-password"
                      v-model="ulogin.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Submit -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="loading"
                @click="mylogin()"
              >
                <b-spinner
                  v-if="loading"
                  variant="light"
                  type="grow"
                  small
                  label="Spinning"
                ></b-spinner>
                <span v-if="!loading">Sign in</span>
              </b-button>
            </b-form>
          </validation-observer>

          <!-- Register Link -->
          <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'form-seller' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import logo from "@/assets/images/logo/Geo-Talent logo.png";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      logo,
      loading: false,
      username: "",
      role: "",
      vendorId: 0,
      status: "",
      password: "",
      userEmail: "",
      sideImg: require("@/assets/images/pages/logo_large.png"),
      required,
      email,
      ulogin: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    mylogin() {
      if (this.ulogin.email !== "" && this.ulogin.password !== "") {
        this.loading = true;
        const axios = require("axios");
        const mydata = {
          username: this.ulogin.email,
          password: this.ulogin.password,
        };
        const config = {
          method: "post",
          url: "https://geotalent-backend-production.up.railway.app/api/tokens/UserLogin",
          data: mydata,
        };

        console.log(mydata)

        axios(config)
          .then((response) => {
            const user = response.data.data;
            const token = response.data?.token;
            console.log(token)
            console.log(user)

            if (!user || !token) {
              this.showError("Please check your email or password is incorrect.");
              this.loading = false;
              return;
            }

            this.username = user.userName;
            this.role = user.role;

            // 🔹 Role store for RBAC + sidebar filter
            localStorage.setItem("role", user.role);
            this.$store.state.userData.role = user.role;

            if (user.status === "active") {
              // store token & userID
              this.$store.state.userData.token = token;
              this.$store.state.userData.userID = user.id;

              this.loading = false;

              // 🔹 Reload page to update sidebar based on role
              location.reload();

              // optional: existing JWT / toast logic
              useJwt
                .login({ email: "admin@demo.com", password: "admin" })
                .then((jwtResponse) => {
                  const { userData } = jwtResponse.data;
                  useJwt.setToken(jwtResponse.data.accessToken);
                  useJwt.setRefreshToken(jwtResponse.data.refreshToken);
                  localStorage.setItem("userData", JSON.stringify(userData));
                  this.$ability.update(userData.ability);

                  this.$store.commit(
                    "app-ecommerce/UPDATE_CART_ITEMS_COUNT",
                    userData.extras.eCommerceCartItemsCount
                  );

                  this.$router
                    .replace(getHomeRouteForLoggedInUser(userData.role))
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                          title: `Welcome ${user.role}`,
                          icon: "CoffeeIcon",
                          variant: "success",
                          text: `You have successfully logged in as ${user.role}. Now you can start exploring!`,
                        },
                      });
                    });
                })
                .catch(() => {
                  this.showError("Error while setting session data.");
                });
            } else if (user.status === "pending") {
              this.showSwal(
                "Please wait..",
                "Your account is in process for approval.",
                "info"
              );
            } else if (user.status === "declined" || user.status === "canceled") {
              this.showSwal(
                "Failed!",
                "Your account approval is canceled for some reasons.",
                "warning"
              );
            } else {
              this.showSwal(
                "Error!",
                "Please check your email or password is correct.",
                "error"
              );
            }
          })
          .catch((error) => {
            console.log(error);
            this.showError("Login failed. Please try again later.");
            this.loading = false;
          });
      } else {
        this.showError("Please fill the form correctly.");
      }
    },

    showSwal(title, text, icon) {
      Swal.fire({
        title,
        text,
        icon,
        iconColor: "#FB595f",
        confirmButtonColor: "#FB595f",
      }).then(() => {
        this.loading = false;
      });
    },

    showError(message) {
      this.$bvToast.toast(message, {
        title: "Error!",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
